export default "__VITE_ASSET__BAI_UrQp__"